export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";